import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { ClipLoader } from "react-spinners";
import api from "../../services/api";
import { AUTOPILOT_COLORS } from "./styles";
import { countMatches, withSearch } from "./searchHighlight";

function TxtViewerModal({ isOpen, onClose, nomeArquivo, idTransportadora, embarcadorId }) {
  const [loading, setLoading] = useState(false);
  const [txt, setTxt] = useState(null);
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(function() {
    if (!isOpen || !nomeArquivo || !idTransportadora) return;
    setLoading(true);
    setTxt(null);
    setError(null);
    setSearch("");
    const params = { nomeArquivo, idTransportadora };
    if (embarcadorId) params.embarcadorId = embarcadorId;
    api.get("/autopilot/insights/fatura/txt", { params })
      .then(function(res) {
        setTxt(res.data.txt);
        setLoading(false);
      })
      .catch(function(err) {
        setError((err.response && err.response.data && err.response.data.error) || "Erro ao carregar arquivo");
        setLoading(false);
      });
  }, [isOpen, nomeArquivo, idTransportadora, embarcadorId]);

  function handleCopy() {
    if (!txt) return;
    navigator.clipboard.writeText(txt).then(function() {
      setCopied(true);
      setTimeout(function() { setCopied(false); }, 2000);
    });
  }

  function handleDownload() {
    const dlParams = { nomeArquivo, idTransportadora, download: "1" };
    if (embarcadorId) dlParams.embarcadorId = embarcadorId;
    api.get("/autopilot/insights/fatura/txt", {
      params: dlParams,
      responseType: "blob",
    }).then(function(res) {
      const url = URL.createObjectURL(new Blob([res.data], { type: "text/plain" }));
      const a = document.createElement("a");
      a.href = url; a.download = nomeArquivo; a.click();
      URL.revokeObjectURL(url);
    }).catch(function(err) {
      console.error("[Autopilot] Erro ao baixar TXT:", err);
    });
  }

  const matchCount = countMatches(txt, search);

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      size="xl"
      fade={false}
      style={{ marginTop: "8vh", marginBottom: "8vh" }}
      contentClassName="cte-details-modal"
      backdropClassName="cte-modal-backdrop"
      wrapClassName="cte-modal-wrap"
    >
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: "var(--everlog-card-hero-bg)",
        borderBottom: `1px solid ${AUTOPILOT_COLORS.border}`,
        padding: "14px 20px",
      }}>
        <span style={{ color: AUTOPILOT_COLORS.statusWarning, fontWeight: 600, fontSize: 14, fontFamily: "monospace" }}>
          {nomeArquivo || "TXT"}
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <input
            type="text"
            value={search}
            onChange={function(e) { setSearch(e.target.value); }}
            placeholder="Pesquisar no arquivo"
            disabled={!txt}
            style={{
              background: "var(--everlog-card-surface-field, var(--everlog-card-surface))",
              border: `1px solid ${AUTOPILOT_COLORS.border}`,
              borderRadius: "4px",
              color: AUTOPILOT_COLORS.title,
              fontSize: "0.75rem",
              padding: "3px 8px",
              width: 170,
            }}
          />
          {search ? (
            <span style={{ fontSize: "0.7rem", color: AUTOPILOT_COLORS.textSoft, whiteSpace: "nowrap" }}>
              {matchCount} {matchCount === 1 ? "ocorrência" : "ocorrências"}
            </span>
          ) : null}
          <button
            onClick={handleDownload}
            disabled={!txt}
            style={{
              background: "none",
              border: `1px solid ${AUTOPILOT_COLORS.border}`,
              borderRadius: "4px",
              color: `color-mix(in srgb, ${AUTOPILOT_COLORS.statusWarning} 80%, transparent)`,
              fontSize: "0.75rem",
              padding: "3px 10px",
              cursor: "pointer",
            }}
          >
            Baixar
          </button>
          <button
            onClick={handleCopy}
            disabled={!txt}
            style={{
              background: "none",
              border: `1px solid ${AUTOPILOT_COLORS.border}`,
              borderRadius: "4px",
              color: copied ? AUTOPILOT_COLORS.statusSuccess : AUTOPILOT_COLORS.textSoft,
              fontSize: "0.75rem",
              padding: "3px 10px",
              cursor: "pointer",
            }}
          >
            {copied ? "Copiado ✓" : "Copiar"}
          </button>
          <button
            onClick={onClose}
            style={{ background: "none", border: "none", color: AUTOPILOT_COLORS.title, fontSize: 24, lineHeight: 1, cursor: "pointer", padding: "0 4px" }}
          >
            ×
          </button>
        </div>
      </div>
      <ModalBody className="everlog-code-viewer" style={{ maxHeight: "65vh", overflow: "auto", padding: "16px 20px" }}>
        {loading && (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <ClipLoader size={28} color={AUTOPILOT_COLORS.statusWarning} />
          </div>
        )}
        {error && (
          <p style={{ color: AUTOPILOT_COLORS.statusDanger, fontSize: "0.85rem" }}>{error}</p>
        )}
        {txt && !loading && (
          <pre style={{ margin: 0, fontFamily: "'Fira Code', 'Courier New', monospace", fontSize: "0.78rem", lineHeight: "1.6", whiteSpace: "pre", color: "var(--everlog-code-text)" }}>
            {search ? withSearch(txt, search, "t") : txt}
          </pre>
        )}
      </ModalBody>
    </Modal>
  );
}

export default TxtViewerModal;
